<template>
    <th :class="( noshow ? '' : 'text-nowrap text-truncate ' ) + align" :width="width">
        <a href="#" @click.prevent="ordenar()" :class="link_class" v-if="!noshow" class="d-print-none">
            <i class="fas fa-sort-down" v-if="value && value.name == sortby && value.direction == 'asc'"></i>
            <i class="fas fa-sort-up" v-else-if="value && value.name == sortby && value.direction == 'desc'"></i>
            <i class="fas fa-sort" v-else></i>
        </a>
        {{ title }}
        <slot></slot>
    </th>
</template>

<script>
export default {
    data () { 
        return { 
            ordem: "",
        }
    }, 

    props: ['title', 'sortby', 'value', 'align', 'link_class', 'noshow', 'width'],

    methods: { 
        ordenar () { 
            if ( this.sortby == this.value.name ) { 
                if ( this.value.direction == 'asc' )
                    this.$emit('input', { name: this.sortby, direction: 'desc' });
                else
                    this.$emit('input', "");
            } else { 
                this.$emit('input', { name: this.sortby, direction: 'asc' });
            }
        }
    }
}
</script>